import React from 'react';
import Modal from './Modal';
import { useNavigate } from 'react-router-dom';
import './Addbenificerymodal.css';

export const Addbenificerymodal = ({ addbenificeryModal, closeAddBeneficiaryModal, openModal }) => {

  const navigate = useNavigate();

  return (

    <div className="modal fade show d-block verificationModel" id="exampleModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true" style={{ background: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header border-bottom-0 ">
            <div className="text-center headerText">
              <h5 className="modal-title" id="exampleModalLabel">Add Beneficiary Details</h5>
            </div>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={closeAddBeneficiaryModal} />
          </div>
          <div className="modal-body ">
            <div className='Flexboxbutton'>

              <button
                className='Addwithabha'
                onClick={openModal}
              >
                Add with ABHA
              </button>

              {/* <div className='Verticalline'></div> */}

              {/* <button
                            className='Addwithoutabha'
                              onClick={() => navigate("/withoutabha")}
                            >
                              Add without ABHA
                            </button> */}

            </div>
          </div>

        </div>
      </div>
    </div>
  )
}
